module.exports = __webpack_public_path__ + "static/story1-menu-thumbnails-400x400-f732c8739f213b3f3047c99d6fc822c4.jpg";